export default {
  baseMaplayers: {
    label: 'Base Layers',
    icon: 'assets/icons/dashboard/layers.svg',
    layers: [
      {
        label: 'Custom Map',
        description:
          'Switch to the custom map with detailed sea and vessel-specific data',
        img: 'assets/icons/dashboard/map-options/world-1.svg',
        layerGroup: [
          {
            hide: false,
            layer: 'naviqore-0',
            startZoom: 0,
            endZoom: 19,
          },
        ],
      },
      {
        label: 'Generic Map',
        description:
          'Switch to a simpler map with basic geographic information',
        img: 'assets/icons/dashboard/map-options/world-2.svg',
        layerGroup: [
          {
            hide: false,
            layer: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
            startZoom: 0,
            endZoom: 19,
          },
        ],
      },
    ],
  },
  overlayLayers: {
    label: 'Overlayers',
    icon: 'assets/icons/dashboard/map-options/Information.svg',
    layers: [
      {
        label: 'Piracy Event Occurancies',
        description: 'High Risk Areas',
        img: 'assets/icons/dashboard/map-options/Piracy%20Events.svg',
        layerGroup: [
          {
            layer: 'asam_events_heatmap',
            startZoom: 0,
            endZoom: 19,
          },
        ],
      },
      {
        label: 'ECAs',
        description: 'IMO Emission Control Areas (SOx,NOx)',
        img: 'assets/icons/dashboard/map-options/Emission%20Control%20Areas.svg',
        layerGroup: [
          {
            layer: 'eca_reg14',
            startZoom: 0,
            endZoom: 8,
          },
        ],
      },
      {
        label: 'Time Zones',
        description: 'Time Zones',
        img: 'assets/icons/dashboard/map-options/Timezones.svg',
        layerGroup: [
          {
            layer: 'ne_10m_time_zones',
            startZoom: 0,
            endZoom: 19,
          },
        ],
      },
      {
        label: 'Graticules 20m',
        description: 'Graticules 20°',
        img: '',
        layerGroup: [
          {
            layer: 'ne_10m_graticules_20',
            startZoom: 0,
            endZoom: 5,
            tooltip: 'Graticules with 20°',
            text: '20°',
          },
          {
            layer: 'ne_10m_graticules_15',
            startZoom: 5,
            endZoom: 6,
            tooltip: 'Graticules with 15°',
            text: '15°',
          },
          {
            layer: 'ne_10m_graticules_10',
            startZoom: 6,
            endZoom: 7,
            tooltip: 'Graticules with 10°',
            text: '10°',
          },
          {
            layer: 'ne_10m_graticules_5',
            startZoom: 7,
            endZoom: 10,
            tooltip: 'Graticules with 5°',
            text: '5°',
          },
        ],
      },
    ],
  },
};
